<template>
	<app-page>
		<app-heading title="Resorts">
			<template v-slot:right>
				<app-button
					color="secondary"
					icon="fa-sync"
					@click="syncShared()"
					v-if="$ravello.can('system.post')"
					small
					outlined
				>
					Sync shared data
				</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="resorts"
					:total="count"
					:headers="headers"
					@update="fetchResorts"
				>
					<template v-slot:actions="{ item }">
						<app-button
							color="secondary"
							:to="{ name: 'studeo-resort', params: { resort: item._id } }"
							icon="fa-eye"
							table
						>
							View
						</app-button>
						<app-button-confirm
							color="secondary"
							icon="fa-sync"
							v-if="$ravello.can('system.post')"
							table
							label-confirm="Sync"
							:description="`Are you sure you want to sync resort <b>${item.name}</b>?`"
							title="Synchronize Resort"
							@click="syncResort(item._id)"
						>
							Sync
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			resorts: [],
			count: -1,
			headers: [{
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: false,
			}, {
				text: 'Enterprise',
				value: 'enterprise.name',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchResorts(pagination) {
			const request = this.$ravello.graphql('resorts')
				.fromPagination(pagination)
				.include(this.$ravello.graphql('enterprise').field('name'))
				.fields(['_id', 'name', 'studeo_id', 'slug'])

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.resorts = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async syncShared() {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('trigger')
					.create({
						event: 'studeo.sync.shared',
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}

			this.$store.dispatch('app/stopLoading')
		},
		async syncResort(id) {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('trigger')
					.create({
						event: 'studeo.sync.resort',
						data: {
							id,
						},
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}

			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
